/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

    export function meevoDateArrayFilter(): any {
    const filter = (array: any, date: any) => {

        var compareDates = (startTime: any, day: any): boolean => {
            if (Array.isArray(startTime) || startTime == undefined || startTime == null) { return false; };
            if (moment(startTime).startOf("day").isSame(moment(day).startOf("day"))) {
                return true;
            }
            return false;
        };

        var returnArray = [];
        angular.forEach(array, (item) => {
            if (compareDates(item.startDateTime, date)) {
                returnArray.push(item);
            }
        })

        return returnArray;
    };
    return filter;
  }


  angular.module("meevo.components.filters")
      .filter("meevoDateArray", meevoDateArrayFilter);
}